import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import Button from './Button';
import DisplayDate from './DisplayDate';
import StatusIcon from './StatusIcon';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchFeedbackItem } from '../api/models/staff-fetch-feedback-item';

interface ProfileFeedbackTypes {
	feedback?: Array<StaffFetchFeedbackItem>;
	defaultMaxItems?: number;
	isPastProfile?: boolean;
}

const ProfileFeedback: React.FC<ProfileFeedbackTypes> = ({ feedback, defaultMaxItems, isPastProfile }) => {
	const [maxFeedbackItem, setMaxFeedbackItem] = React.useState<number>(defaultMaxItems || 5);

	return (
		<>
			{feedback && feedback.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Feedback</h2>
					</div>

					{feedback.slice(0, maxFeedbackItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto full-width">
										<div className="row detail-info">
											<div className="col-lg-3 detail-name">{item.subject}</div>

											<div className={`col-lg-2 detail-label ${item.status?.toLowerCase()}`}>{item.feedbackStatus}</div>

											<div className="col-lg-4 detail-status">
												<div className="title">{item.updated ? <>Last updated</> : <>Submitted</>}</div>

												<time className="name">
													<DisplayDate>{item.updated ? item.updated : item.created}</DisplayDate>
												</time>
											</div>

											<div className="col-lg-3 detail-status">
												<div className="title">By</div>
												<div className="status">{item.creator}</div>
											</div>
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										{item.status === 'Success' || isPastProfile ? (
											<Link className="btn-text pdr-0" to={`/feedback/${item.id}`}>
												View
											</Link>
										) : (
											<Link className="btn-text pdr-0" to={`/feedback/${item.id}`}>
												Review
											</Link>
										)}
									</div>
								</div>
							</div>
						);
					})}

					{maxFeedbackItem < feedback.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxFeedbackItem(feedback.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {feedback.length - maxFeedbackItem} more
						</Button>
					)}
				</section>
			)}
		</>
	);
};

export default ProfileFeedback;
